<template>
  <div
    class="w-full h-full rounded-2xl overflow-hidden">
    <img
      src="https://resources.businessdraft.com/business-draft-ai-avatar-v1.jpg"
      alt="Business Draft AI Avatar"
      class="object-cover"
      height="512"
      width="512"
    />
  </div>
</template>
